import React from 'react'

import classNames from 'classnames'

type ReportQueueItemProps = {
  report: {
    itemId: string
    name: string
  }
  active: boolean
  onClick: (itemId: string) => void
}
const ReportQueueItem = ({ onClick, report, active }: ReportQueueItemProps) => {
  const activeQueueItem = classNames({ expense_queue__item__active: active })

  return (
    <div
      className={`${activeQueueItem} expense_queue__item cursor_pointer`}
      onClick={() => {
        onClick(report.itemId)
      }}
    >
      <div className="flex__space_between font-16">{report.name}</div>
    </div>
  )
}

export default ReportQueueItem
